export function LayoutsError(props) {
    const { children } = props;
    return children;
  }
  